import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsInputModule } from '@shared/core/modules/forms/components/formsInput';
import { PickupForScheduleMockComponent } from './pickup-for-schedule-mock.shared.component';

@NgModule({
    declarations: [
        PickupForScheduleMockComponent
    ],
    imports: [
        CommonModule,
        FormsInputModule,
    ],
    exports: [
        PickupForScheduleMockComponent
    ],
})
export class PickupForScheduleMockModule { }
